import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { Container, FormText ,Row, Col} from 'react-bootstrap';
import {Button} from 'react-bootstrap';
import i1 from '../../Assets/i1.png'
import Card from 'react-bootstrap/Card';
import whatsapp from '../../Assets/whatsapp.png'
import { Player } from '@lottiefiles/react-lottie-player';
import whtsapplottie from '../../Assets/lottie/whatsapp.json';


function ServicesForm(props) {
   
  const text =
    "+291 7596606"
    function CopyButton()
    {
      navigator.clipboard.writeText(text);
    }
  return (
    <div>
     <Container fluid className="home-about-section " id="about">
     
     <Container>
      <h3 className="heading-nae" style={{ justifyContent: "center", paddingTop: "140px" }}>
            <strong className="white" >Thanks For Reaching Out! Contact Us now and get your job done</strong>
      </h3>
      <div style={{ display: 'flex-right',float:'right'}}>
        </div>
    <div style={{ paddingTop:'50px' }}>
  
    </div>

      <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>

      <Col xs={1} md={8} className="tech-icons">
     
            <Player
        src={whtsapplottie}
        className="player"
        loop
        autoplay
        direction={-1}
        speed={1}
        style={{ height: '200px', width: '200px' }}
      />
    
   <u><h1 className="white">WhatsApp Us  </h1> </u>
     <div className='white'>
      <Card.Body>
        <Card.Title>Contact Us through this Number! በዚ አድራሻ ብ ዋትስ ኣፕ ርኸቡና</Card.Title>
      
        <Card.Text ><h1 className='green'>+291 7596606</h1>
        <Button variant="ligh" className ='green btn btn-success'onClick={CopyButton}>Copy</Button>{' '}
        </Card.Text>
        
      </Card.Body>

      
    </div>
      </Col>  
      </Row>
 
      </Container>
    </Container>

    </div>
  )

}

export default ServicesForm
